export type Language = {
	code: string
	name: string
	flag: string
}

export const getLanguages = (): Language[] => {
	return [
		{ code: 'en', name: 'English', flag: 'gb' },
		{ code: 'es', name: 'Español', flag: 'es' },
		{ code: 'fr', name: 'Français', flag: 'fr' },
		{ code: 'de', name: 'Deutsch', flag: 'de' },
		{ code: 'it', name: 'Italiano', flag: 'it' },
		{ code: 'pt', name: 'Português', flag: 'pt' },
	]
}
